const FORM_SELECTOR = "[data-clinician-licensing-form]";

function templateHtml(form, selector, replacements) {
  let html = form.querySelector(selector).innerHTML;

  Object.entries(replacements).forEach(([placeholder, value]) => {
    html = html.replaceAll(placeholder, String(value));
  });

  return html;
}

function nextIndex(element, attribute) {
  const index = Number.parseInt(element.dataset[attribute] || "0", 10);
  element.dataset[attribute] = String(index + 1);
  return index;
}

function stateName(select) {
  return select.value ? select.options[select.selectedIndex].textContent : "New state";
}

function updateStateOptions(form) {
  const selects = Array.from(form.querySelectorAll("[data-licensed-state-select]"));
  const selectedCodes = selects.map((select) => select.value).filter(Boolean);

  selects.forEach((select) => {
    Array.from(select.options).forEach((option) => {
      if (!option.value) return;

      option.disabled = selectedCodes.includes(option.value) && option.value !== select.value;
    });
  });
}

function updateStatePresentation(form) {
  const states = Array.from(form.querySelectorAll("[data-licensed-state]"));

  states.forEach((state, index) => {
    const select = state.querySelector("[data-licensed-state-select]");
    state.querySelector("[data-state-number]").textContent = String(index + 1);
    state.querySelector("[data-state-title]").textContent = stateName(select);
    state.querySelector("[data-remove-licensed-state]").setAttribute(
      "aria-label",
      `Remove ${select.value ? stateName(select) : "state license"}`
    );
    state.querySelectorAll("[data-required-when-present]").forEach((input) => {
      input.required = true;
    });
  });

  form.querySelector("[data-licensing-empty]").classList.toggle("hidden", states.length > 0);
  updateStateOptions(form);
}

function addCustomInsurer(form, state) {
  const insurers = state.querySelector("[data-custom-insurers]");
  const customIndex = nextIndex(insurers, "nextCustomIndex");

  insurers.insertAdjacentHTML(
    "beforeend",
    templateHtml(form, "[data-custom-insurer-template]", {
      "__STATE_INDEX__": state.dataset.stateIndex,
      "__CUSTOM_INDEX__": customIndex
    })
  );

  insurers.lastElementChild.querySelector("[data-custom-insurer-name]").focus();
}

function addState(form) {
  const stateIndex = nextIndex(form, "nextStateIndex");
  const states = form.querySelector("[data-licensed-states]");

  states.insertAdjacentHTML(
    "beforeend",
    templateHtml(form, "[data-licensed-state-template]", {
      "__STATE_INDEX__": stateIndex
    })
  );

  updateStatePresentation(form);
  states.lastElementChild.querySelector("[data-licensed-state-select]").focus();
}

function handleClick(form, event) {
  const state = event.target.closest("[data-licensed-state]");

  if (event.target.closest("[data-add-licensed-state]")) {
    addState(form);
  } else if (event.target.closest("[data-remove-licensed-state]")) {
    state.remove();
    updateStatePresentation(form);
  } else if (event.target.closest("[data-add-custom-insurer]")) {
    addCustomInsurer(form, state);
  } else if (event.target.closest("[data-remove-custom-insurer]")) {
    event.target.closest("[data-custom-insurer-row]").remove();
  }
}

function handleKeydown(form, event) {
  if (event.key !== "Enter" || event.isComposing || !event.target.matches("[data-custom-insurer-name]")) return;

  // Custom payors behave like tags: Enter keeps the current value and starts the next one.
  event.preventDefault();
  if (!event.target.value.trim()) return;

  addCustomInsurer(form, event.target.closest("[data-licensed-state]"));
}

function bootForm(form) {
  if (form.dataset.licensingInitialized !== "true") {
    form.addEventListener("click", (event) => handleClick(form, event));
    form.addEventListener("keydown", (event) => handleKeydown(form, event));
    form.addEventListener("change", (event) => {
      if (event.target.matches("[data-licensed-state-select]")) {
        updateStatePresentation(form);
      }
    });
    form.dataset.licensingInitialized = "true";
  }

  updateStatePresentation(form);
}

function bootClinicianLicensingForms() {
  document.querySelectorAll(FORM_SELECTOR).forEach(bootForm);
}

document.addEventListener("DOMContentLoaded", bootClinicianLicensingForms);
// Browsers may restore form values from the back-forward cache after DOMContentLoaded.
window.addEventListener("pageshow", bootClinicianLicensingForms);
